export default "__VITE_ASSET__BCqaVqOO__"